"use client";
import EventPageError from "@features/eventPage/display/error";

// Error components must be Client Components

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return <EventPageError error={error} reset={reset} />;
}
